import React, { forwardRef } from 'react';

import { Dialog, DialogContent } from '../../components/material-ui/Dialog';
import { AlertSettings } from './AlertSettings/AlertSettings';
import { DateTimeSetting } from './DateTimeSetting/DateTimeSetting';
import { EnrouteSetting } from './EnrouteSetting/EnrouteSetting';
import { GpsSetting } from './GpsSetting/GpsSetting';
import { PartitionSetting } from './PartitionSetting/PartitionSetting';
import { SettingActions } from './SettingActions/SettingActions';
import { SettingTabs } from './SettingTabs/SettingTabs';
import { useChangeAlertInterval } from './AlertSettings/hooks/useChangeAlertInterval';
import { useEnrouteSetting } from './EnrouteSetting/useEnrouteSetting';
import { useGpsSetting } from './GpsSetting/useGpsSetting';
import { usePartitionSetting } from './PartitionSetting/usePartitionSetting';
import { useSetting } from './useSetting';
import { useStyles } from './useStyles';

import './Setting.scss';

export const Setting = forwardRef((props, ref) => {
    const { allowed, interval, allowedChangeHandler, intervalChangeHandler } = useChangeAlertInterval();

    const {
        gps,
        handleChangeSelectionType,
        handleChangeSlider,
        handleSliderDown,
        handleSliderUp
    } = useGpsSetting();

    const {
        columns,
        selected,
        selectedAll,
        handleRowSelection,
        handleToggleAll
    } = useEnrouteSetting();

    const { partitions, setPartitions, handleResetClick, handleCheckItem } = usePartitionSetting();

    const {
        tabIndex,
        timePickerType,
        handleChangeTimePickerType,
        handleClose,
        handleSave,
        handleSelect
    } = useSetting(interval, allowed, gps, partitions, selected);

    const classes = useStyles();

    return (
        <Dialog open={true} onClose={handleClose} className="datetime-popup" fullScreen={true}>
            <DialogContent style={{ padding: 0 }} ref={ref}>
                <SettingTabs onChange={handleSelect} tabIndex={tabIndex} />
                <div className={classes.contentWrapper}>
                    {tabIndex === 0 && <DateTimeSetting onChange={handleChangeTimePickerType} timePickerType={timePickerType} />}
                    {tabIndex === 1 && (
                        <GpsSetting
                            allowedDistance={gps.allowedDistance}
                            selectionType={gps.selectionType}
                            onChangeSlider={handleChangeSlider}
                            onSliderUp={handleSliderUp}
                            onSliderDown={handleSliderDown}
                            onChangeSelectionType={handleChangeSelectionType}
                        />
                    )}
                    {tabIndex === 2 && (
                        <EnrouteSetting
                            columns={columns}
                            selected={selected}
                            selectedAll={selectedAll}
                            onRowSelection={handleRowSelection}
                            onToggleAll={handleToggleAll}
                        />
                    )}
                    {tabIndex === 3 && (
                        <AlertSettings
                            allowed={allowed}
                            interval={interval}
                            onToggle={allowedChangeHandler}
                            onChange={intervalChangeHandler}
                        />
                    )}
                    {tabIndex === 4 && (
                        <PartitionSetting
                            partitions={partitions}
                            setPartitions={setPartitions}
                            onResetClick={handleResetClick}
                            onCheckItem={handleCheckItem}
                        />
                    )}
                </div>
            </DialogContent>
            <SettingActions onClose={handleClose} onSave={handleSave} />
        </Dialog>
    );
});
